import { useApolloClient } from '@apollo/client';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalFooterButtons,
  ModalHeader,
} from '@televet/kibble-ui/build/components/Modal';
import React from 'react';
import { useDeleteOneUserAppointmentGroupingMutation, GetUserAppointmentGroupingsDocument } from 'shared/types/graphql';

interface DeleteAppointmentGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedGroupId: string;
}

const DeleteAppointmentGroupModal = ({
  isOpen,
  selectedGroupId,
  onClose,
}: DeleteAppointmentGroupModalProps): JSX.Element => {
  const apolloClient = useApolloClient();

  const [deleteOneUserAppointmentGrouping, { loading: isDeletingAppointmentGroup }] =
    useDeleteOneUserAppointmentGroupingMutation({
      refetchQueries: [GetUserAppointmentGroupingsDocument],
    });

  const onConfirmDeleteAppointmentGroup = (id: string): void => {
    deleteOneUserAppointmentGrouping({ variables: { where: { id } } }).then(() => {
      apolloClient.cache.evict({ id: `UserAppointmentGrouping:${id}` });
    });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalCloseButton />
      <ModalHeader>Delete Appointment Column</ModalHeader>
      <ModalBody>Are you sure you want to delete this column?</ModalBody>
      <ModalFooterButtons
        isDestructive
        submitText="Delete Column"
        onSubmit={(): void => onConfirmDeleteAppointmentGroup(selectedGroupId)}
        isLoading={isDeletingAppointmentGroup}
      />
    </Modal>
  );
};

export default DeleteAppointmentGroupModal;
